import { render, staticRenderFns } from "./SponsoredRecommendationImage.vue?vue&type=template&id=80086e2e&scoped=true"
import script from "./SponsoredRecommendationImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationImage.vue?vue&type=style&index=0&id=80086e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80086e2e",
  null
  
)

export default component.exports